<template>
  <v-dialog
    v-model="dialog"
    max-width="320px"
  >
    <v-card>
      <v-card-title class="headline">Sign out</v-card-title>

      <v-card-text>
        Do you want to sign out?
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="secondary"
          text
          v-on:click="signoutCanceled"
        >
          No
        </v-btn>

        <v-btn
          color="primary"
          text
          v-on:click="signout"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Signout',
  props: [ 'show' ],
  computed: {
    dialog: {
      get () {
        return this.show
      },
      set (value) {
        this.$emit('update:show', value)
      }
    }
  },
  methods: {
    signoutCanceled () {
      this.dialog = false
    },
    async signout () {
      await this.$store.dispatch('signout')

      this.dialog = false

      this.$router.push('/')
    }
  }
}
</script>